// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orders-search-results-vue[data-v-14fb0288]{min-height:300px}.opacity-75[data-v-14fb0288]{opacity:.75}", ""]);
// Exports
module.exports = exports;
